"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInMobileTray = exports.signInMobileMenuId = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const shared_1 = require("../../shared");
const tray_1 = require("../tray");
exports.signInMobileMenuId = "signin-mobile";
const Styled = styled_components_1.default.div `
	visibility: ${(p) => (p.menuOpen ? "visible" : "hidden")};
	&:hover {
		visibility: visible;
	}
	position: absolute;
	top: 0;
	background: ${(p) => p.theme.palette.background.paper};
	left: ${(p) => (p.menuOpen ? 0 : "100%")};
	transition: left 0.2s ease-in-out;
	width: 100%;
	height: 100%;
`;
const SignInMobileTray = ({ hide, isLoggedIn, accountLinks = {}, locale, }) => {
    const { messages } = (0, shared_1.useMessages)();
    const { menuOpen, setMenuOpen } = (0, shared_1.useSignInMobileTray)();
    const toggleMenu = (0, shared_1.useToggleMenu)(menuOpen, setMenuOpen, exports.signInMobileMenuId);
    const onKeyUp = (0, shared_1.useHandleKeyUp)(toggleMenu, toggleMenu);
    if (hide)
        return null;
    const { signInLinks = [], signOutLink, dropdownLinks = [] } = accountLinks;
    const signInDropdown = (signInLinks === null || signInLinks === void 0 ? void 0 : signInLinks.length) && signInLinks.length > 1;
    const loggedInLinks = [...dropdownLinks, Object.assign({ title: messages.sign_out }, signOutLink)];
    if (!isLoggedIn && !signInDropdown)
        return null;
    return (react_1.default.createElement(Styled, { menuOpen: menuOpen },
        react_1.default.createElement(tray_1.TrayContent, { className: "tray-content", menuOpen: menuOpen },
            react_1.default.createElement(tray_1.BackTrayItem, { toggleMenu: toggleMenu, menuOpen: menuOpen, onKeyUp: onKeyUp }),
            react_1.default.createElement(tray_1.MobileLinks, { menuOpen: menuOpen, links: isLoggedIn ? loggedInLinks : signInLinks, locale: locale }))));
};
exports.SignInMobileTray = SignInMobileTray;
//# sourceMappingURL=SignInMobileTray.js.map